import { apiService } from './api';
import { ApiResponse } from '../types';

interface NotificationPreferences {
  email: boolean;
  sms: boolean;
  whatsapp: boolean;
  inApp: boolean;
}

interface NotificationSettings {
  whatsappNumber?: string;
  quietHours?: {
    enabled: boolean;
    start: string;
    end: string;
  };
  sound?: boolean;
  vibration?: boolean;
}

interface CommunicationPreferences {
  preferredChannel?: 'email' | 'sms' | 'whatsapp' | 'inApp';
  digestPreference?: 'instant' | 'daily' | 'weekly';
}

interface NotificationPreferencesData {
  notificationPreferences?: NotificationPreferences;
  notificationSettings?: NotificationSettings;
  communicationPreferences?: CommunicationPreferences;
}

export const getNotificationPreferences = async (): Promise<ApiResponse<NotificationPreferencesData>> => {
  const response = await apiService.get('/notifications/preferences');
  return response.data;
};

export const updateNotificationPreferences = async (
  data: NotificationPreferencesData
): Promise<ApiResponse<NotificationPreferencesData>> => {
  const response = await apiService.put('/notifications/preferences', data);
  return response.data;
};

export const sendTestNotification = async (data: {
  service?: string;
  testMessage?: string;
}): Promise<ApiResponse<any>> => {
  const response = await apiService.post('/notifications/test', data);
  return response.data;
};

export const sendTestNotificationToUser = async (data: {
  userId?: string;
  userEmail?: string;
  userPhone?: string;
  service?: string;
  message?: any;
  plainText?: string;
  useAI?: boolean;
  respectPreferences?: boolean;
  category?: string;
}): Promise<ApiResponse<any>> => {
  const response = await apiService.post('/notifications/test-user', data);
  return response.data;
};

export const getNotificationLogs = async (params?: {
  page?: number;
  limit?: number;
  startDate?: string;
  endDate?: string;
  userId?: string;
  email?: string;
  phone?: string;
  service?: string;
  category?: string;
  success?: boolean;
  companyId?: string;
  search?: string;
}): Promise<ApiResponse<any>> => {
  const response = await apiService.get('/notifications/logs', { params });
  return response.data;
};

export const getNotificationLogDetails = async (id: string): Promise<ApiResponse<any>> => {
  const response = await apiService.get(`/notifications/logs/${id}`);
  return response.data;
};

export const getNotificationLogStats = async (params?: {
  startDate?: string;
  endDate?: string;
  companyId?: string;
  userId?: string;
}): Promise<ApiResponse<any>> => {
  const response = await apiService.get('/notifications/logs/stats', { params });
  return response.data;
};

export const getUnreadNotificationCount = async (): Promise<ApiResponse<{ unreadCount: number }>> => {
  const response = await apiService.get('/inapp-notifications/unread-count');
  return response.data;
};